import React from 'react';
import { motion } from 'framer-motion';
interface PageHeroProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  bgImage?: string;
}
export function PageHero({
  eyebrow,
  title,
  subtitle,
  bgImage
}: PageHeroProps) {
  return <section className="relative w-full min-h-[280px] md:min-h-[360px] flex items-center overflow-hidden bg-[#0A71B1]" data-id="element-236">
      {bgImage && <>
          <img src={bgImage} alt="" className="absolute inset-0 w-full h-full object-cover" aria-hidden="true" data-id="element-237" />
          <div className="absolute inset-0 bg-[#0A71B1]/80" data-id="element-238" />
        </>}
      {!bgImage && <div className="absolute inset-0 bg-gradient-to-br from-[#0A71B1] via-[#085d91] to-[#3a9ad4]" data-id="element-239" />}

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-16 md:py-20" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="max-w-3xl" data-id="element-241">
          {eyebrow && <p className="text-sm font-bold tracking-[0.2em] uppercase text-teal-300 mb-4" data-id="element-242">
              {eyebrow}
            </p>}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-4" data-id="element-243">
            {title}
          </h1>
          {subtitle && <p className="text-lg md:text-xl text-white/80 leading-relaxed max-w-2xl" data-id="element-244">
              {subtitle}
            </p>}
        </motion.div>
      </div>
    </section>;
}